/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Work_0_BadgeInputs */

const en_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh catalog content`)
};

const ar_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى كتالوج حديث`)
};

const bn_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তাজা ক্যাটালগ কনটেন্ট`)
};

const de_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frische Kataloginhalte`)
};

const es_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido de catálogo fresco`)
};

const fr_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu de catalogue frais`)
};

const pt_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo de catálogo fresco`)
};

const zh_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新鲜的目录内容`)
};

const tr_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taze katalog içeriği`)
};

const ru_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свежий каталожный контент`)
};

const pl_svc_programmatic_seo_work_0_badge = /** @type {(inputs: Svc_Programmatic_Seo_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Świeże treści katalogowe`)
};

/**
* | output |
* | --- |
* | "Fresh catalog content" |
*
* @param {Svc_Programmatic_Seo_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_work_0_badge = /** @type {((inputs?: Svc_Programmatic_Seo_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "de") return de_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "es") return es_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_work_0_badge(inputs)
	return en_svc_programmatic_seo_work_0_badge(inputs)
});
export { svc_programmatic_seo_work_0_badge as "svc_programmatic-seo_work_0_badge" }